import React, { useCallback } from 'react';
import css from '~/features/dashboard/components/quick-song-entry/styles.module.scss';
import { Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import { TextInput } from '~/features/dashboard/components/add-deal/components/text-input';
import { INewQuickSongFormInputs } from '~/models/music/new-song/formInputs';
import { createNewQuickSongEntryThunk } from '~/features/dashboard/store/actions.thunks';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { useForm } from 'react-hook-form';
import classNames from 'classnames';

interface MyCreateSongProps {
    creatorId: number;
    rows: INewQuickSongFormInputs[];
    addRows: (e: INewQuickSongFormInputs) => void;
}

export const CreateQuickSongEntry: React.FC<MyCreateSongProps> = ({ creatorId, rows, addRows }) => {
    const dispatch = useThunkDispatch();

    const { register, handleSubmit, setValue, errors } = useForm<INewQuickSongFormInputs>({
        defaultValues: {},
    });

    const onSubmit = useCallback(
        (data: INewQuickSongFormInputs) => {
            dispatch(createNewQuickSongEntryThunk({ ...data, creatorId })).then(res => {
                setValue('songName', '');
                res?.gSongRef &&
                    addRows({
                        entryID: Number(res.gSongEntryID),
                        songName: res.gSongName,
                        songRef: res.gSongRef,
                        writerName: res.gMyWriterName,
                        writerShare: res.gWriterShare,
                        pubName: res.gPublisherName,
                        pubShare: res.gPublishingShare,
                        artist: res.gSongMainArtist,
                        releaseDate: res.gSongReleaseDate,
                        releaseYear: res.gSongReleaseYear,
                        ISRC: res.gSongISRC,
                        UPC: res.gSongUPC,
                    });
            });
        },
        [dispatch] // eslint-disable-line
    );

    return (
        <form className={css.form} onSubmit={handleSubmit(onSubmit)}>
            <Grid container style={{ justifyContent: 'center' }}>
                <Grid item xs={3}>
                    <Typography className={classNames('publish-title', css.typography2)} variant="h6">
                        What is your Song's name?
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <TextInput
                        className={css.textInput}
                        label={''}
                        name={'songName'}
                        register={register({ required: 'Song name is required' })}
                        fieldError={errors.songName}
                    />
                </Grid>
                <Grid item xs={3}>
                    <Button className={css.saveButtonSingle} type={'submit'}>
                        Save
                    </Button>
                </Grid>
                {rows.length > 0 && (
                    <Grid item xs={8}>
                        <TableContainer component={Paper} className={css.tableQuickDates}>
                            <Table size="small" aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ width: '5%' }} align="center">
                                            №
                                        </TableCell>
                                        <TableCell align="left">Song Name</TableCell>
                                        <TableCell align="left">Writer Name</TableCell>
                                        <TableCell align="left">Publisher Name</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row, index) => (
                                        <TableRow key={`row-${row.songRef}`}>
                                            <TableCell style={{ width: '5%' }} align="center">
                                                <p>{index + 1}</p>
                                            </TableCell>
                                            <TableCell>
                                                <p className={css.tableText}>{row.songName}</p>
                                            </TableCell>
                                            <TableCell>
                                                <p className={css.tableText}>{row.writerName}</p>
                                            </TableCell>
                                            <TableCell>
                                                <p className={css.tableText}>{row.pubName}</p>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                )}
            </Grid>
        </form>
    );
};
